import {Component, OnInit} from '@angular/core';
import {ReferralService} from '../../../shared/services/referral.service';
import {ReferralApiService} from '../../../shared/services/referral-api.service';
import {RefPromptService} from '../shared/ref-prompt.component';

type PayoutAccountType = 'BANK' | 'UPI';

interface PayoutAccountRow {
    id: number;
    referrerName: string;
    referrerCode: string;
    type: PayoutAccountType;
    accountHolderName: string;
    bankName: string;
    accountNumberMasked: string;
    ifsc: string;
    upiId: string;
}

@Component({
    selector: 'app-referral-payout-accounts',
    templateUrl: './referral-payout-accounts.component.html'
})
export class ReferralPayoutAccountsComponent implements OnInit {
    list: PayoutAccountRow[] = [];
    loading = false;

    constructor(private referralService: ReferralService,
                private referralApi: ReferralApiService,
                private prompt: RefPromptService) {
    }

    ngOnInit() {
        this.load();
    }

    load() {
        this.loading = true;
        // SUBMITTED + UNDER_REVIEW: awaiting a decision, same bucket convention used by the
        // KYC and payouts queues.
        this.referralApi.getPayoutAccounts({status: 'SUBMITTED,UNDER_REVIEW', per_page: 100}).subscribe({
            next: (data: any) => {
                this.list = (data?.data ?? []).map((r: any) => this.toRow(r));
                this.loading = false;
            },
            error: () => {
                this.list = [];
                this.loading = false;
            }
        });
    }

    private toRow(r: any): PayoutAccountRow {
        return {
            id: r.id,
            referrerName: r.referrer?.name ?? '—',
            referrerCode: r.referrer?.referral_code ?? '',
            type: r.payout_type,
            accountHolderName: r.account_holder_name,
            bankName: r.bank_name,
            accountNumberMasked: r.account_number_masked,
            ifsc: r.ifsc,
            upiId: r.upi_id
        };
    }

    verify(row: PayoutAccountRow) {
        this.referralApi.verifyPayoutAccount(row.id).subscribe(() => {
            this.referralService.toast(`Payout account verified for ${row.referrerName}`);
            this.load();
        });
    }

    async reject(row: PayoutAccountRow) {
        const reason = await this.prompt.ask({
            title: `Reject payout account for ${row.referrerName}?`,
            text: 'The partner will see your reason and can submit their bank/UPI details again.',
            label: 'Reason',
            okText: 'Reject account',
            check: v => v.trim().length >= 3 ? '' : 'Enter at least 3 characters.'
        });
        if (reason !== null) {
            this.referralApi.rejectPayoutAccount(row.id, {reason}).subscribe(() => {
                this.referralService.toast('Payout account rejected');
                this.load();
            });
        }
    }
}
